import React, { useState } from "react";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import ColorPicker from "./ColorPicker";
import RangeSlider from "./RangeSlider";
const ThemeSection = ({
  title,
  sectionKey,
  properties,
  themeValues,
  onThemeChange,
  defaultExpanded = true,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className="css-section">
      <div className="section-header" onClick={() => setIsExpanded(!isExpanded)}>
        <h3>{title}</h3>
        {isExpanded ? <MdExpandLess size={24} /> : <MdExpandMore size={24} />}
      </div>

      {isExpanded && (
        <div className="section-content">
          {Object.entries(properties).map(([propertyKey, config]) => {
            const themeKey = `${sectionKey}_${propertyKey}`;
            const currentValue = themeValues[themeKey];

            return config.type === "range" ? (
              <RangeSlider
                key={themeKey}
                label={config.label}
                value={currentValue}
                onChange={(color) => onThemeChange(themeKey, color)}
              />
            ) : (
              <ColorPicker
                key={themeKey}
                label={config.label}
                value={currentValue}
                onChange={(color) => onThemeChange(themeKey, color)}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ThemeSection;
